<template>
  <transition
      enter-active-class="transition ease-out duration-100 transform"
      enter-from-class="opacity-0 scale-95"
      enter-to-class="opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75 transform"
      leave-from-class="opacity-100 scale-100"
      leave-to-class="opacity-0 scale-95"
  >
    <div class="rounded-r-md p-2 border-l-4" :class="cls.border">
      <div class="flex">
        <div class="flex">
          <svg v-if="showIcon" class="h-6 w-6 my-auto" :class="cls.icon" fill="none" viewBox="0 0 24 24"
               stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" :d="icon"/>
          </svg>
        </div>
        <div class="ml-3">
          <slot><p class="text-sm text-yellow-700"> text template</p></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "UiAlert",
  props: {
    type: {
      type: String,
      default: 'warning',
    },
    showIcon: {
      default: true,
    }
  },
  data() {
    return {
      types: {
        info: {
          cls: {border: 'bg-blue-50 border-blue-500', icon: 'text-blue-400'},
          icon: 'M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
        },
        warning: {
          cls: {border: 'bg-yellow-50 border-yellow-500', icon: 'text-yellow-400'},
          icon: 'M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
        },
        danger: {
          cls: {border: 'bg-red-50 border-red-500', icon: 'text-red-400'},
          icon: 'M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z'
        },
        success: {
          cls: {border: 'bg-green-50 border-green-500', icon: 'text-green-400'},
          icon: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'
        },
      }
    }
  },
  computed: {
    cls() {
      return this.types[this.type].cls
    },
    icon() {
      return this.types[this.type].icon
    },
  }
}
</script>

<style scoped>

</style>